import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b8004a2&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8004a2",
  null
  
)

export default component.exports